import React, {useCallback} from 'react';
import {Icon} from 'shared/helpers';
import {OverlayTrigger} from 'shared/components/OverlayTrigger';
import FloatingMenuButton from 'components/customer/RoomPlanner/components/common/FloatingMenuButton';
import useAutoSave from 'components/customer/RoomPlanner/lib/useAutoSave';
import {useRoomPlannerContext} from 'components/customer/RoomPlanner/components/RoomPlannerContext';

const MoveDown = () => {
    const {selectedCabinetGroup} = useRoomPlannerContext();
    const {debouncedSave} = useAutoSave();

    const userData = selectedCabinetGroup?.userData as {
        values?: {
            template_3d?: Array<{
                attributes?: {
                    variables?: string;
                };
            }>;
        };
        moveDown?: () => void;
    };

    const templateVariables =
        userData?.values?.template_3d?.[0]?.attributes?.variables;
    let isUpperProduct = false;

    if (templateVariables) {
        try {
            isUpperProduct =
                selectedCabinetGroup.userData.isUpperProduct ?? false;
        } catch (e) {}
    }

    const handleMoveDown = useCallback(() => {
        if (typeof userData?.moveDown === 'function') {
            userData.moveDown();
            debouncedSave(selectedCabinetGroup);
        }
    }, [userData, debouncedSave, selectedCabinetGroup]);

    // TODO: Temporarily hidden - may be re-enabled in the future
    // Remove this condition to show the Move Down button again
    if (!isUpperProduct || true) {
        return null;
    }

    return (
        <OverlayTrigger placement="top" overlay={<strong>Move Down</strong>}>
            <FloatingMenuButton onClick={handleMoveDown}>
                <Icon
                    className="icon_button"
                    color="#b2bec3"
                    iconName={'Button-Down.svg'}
                />
            </FloatingMenuButton>
        </OverlayTrigger>
    );
};

export default MoveDown;
